
export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Start a party',
      description: 'One player hosts the game.',
    },
    {
      number: '02',
      title: 'Everyone joins',
      description: 'Friends join from their own phones.',
    },
    {
      number: '03',
      title: 'Play live',
      description: 'Vote, react, and watch the chaos unfold in real time.',
    }
  ];

  return (
    <section id="how-it-works" className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-20 text-[#0084F4]" style={{ lineHeight: '1.3' }}>
          How it works
        </h2>

        <div className="grid md:grid-cols-3 gap-12 md:gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative text-center">
              <div className="text-8xl md:text-9xl font-black bg-gradient-to-b from-white/40 to-white/5 bg-clip-text text-transparent mb-4 leading-none">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold mb-3">{step.title}</h3>
              <p className="text-gray-300 text-lg leading-relaxed max-w-xs mx-auto">{step.description}</p>
              
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 -right-4 transform z-10">
                  <i className="ri-arrow-right-line text-2xl text-gray-700"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center space-y-3">
          <p className="text-gray-400 text-lg">
            <span className="text-white font-semibold">Best for 2–10 players.</span> Perfect for house parties, trips, pregames, and dates.
          </p>
          <p className="text-gray-500">
            Takes under 30 seconds to start a party.
          </p>
        </div>
      </div>
    </section>
  );
}
